import type { IThemeComponents } from '@bingads-webui-react/with-default-styles';

import type { CouponBannerCoreStyles } from './types';

export const getStyle = (_: IThemeComponents, { palette = {} }: CouponBannerCoreStyles) => ({
  alertList: {
    'list-style': 'none',
    'padding-left': 0,
    'margin-bottom': 0,
    '& .coupon-icon-svg': {
      fontSize: '16px !important',
      lineHeight: '12px !important',
    },
  },

  signupBannerNoteStyle: {
    height: '32px',
    minHeight: '32px',
    width: '100%',
    backgroundColor: '#038387',
    display: 'flex',
    alignItems: 'center',
    color: palette.white,
    fontSize: '14px',
  },

  signupReferralText: {
    padding: '0 15px',
  },

  signupCouponText: {
    padding: '0 5px',
  },

  signupCouponIcon: {
    paddingLeft: '15px',
  },

  signupLink: {
    textDecoration: 'underline',
    padding: 5,
    color: `${palette.white} !important`,
    '&:hover': {
      cursor: 'pointer',
      color: palette.white,
    },
    '&:focus': {
      outline: `1px solid ${palette.white}`,
      color: `${palette.white} !important`,
    },
    '&:focus:hover': {
      outline: `2px solid ${palette.white}`,
    },
    '&.selected': {
      outline: `1px solid ${palette.white}`,
      color: `${palette.white} !important`,
      '&:hover, &:focus': {
        outline: `1px solid ${palette.white}`,
      },
      '&:focus:hover': {
        outline: `2px solid ${palette.white}`,
      },
    },
  },

  linkStyle: {
    color: palette.white,
    fontSize: '14px',
  },
});
